/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";

const Container = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  text-align: center;

  :not(:last-of-type) {
    margin: 0 0 24px;
  }

  :not(:last-of-type):after {
    content: "";
    display: block;
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    height: 0px;
    border-bottom: 1px solid ${props => props.theme.mainSeparator};
  }

  ${props =>
    props.share &&
    (props.share === 3
      ? css`
        @media(min-width:480px) and (max-width: 959px) {
          width: ${props => 100 / props.share}%;
        }
        `
      : css`
          width: ${props => 100 / props.share}%;
        `)}

  ${props =>
    props.buttonRow &&
    css`
    align-items: center;
    align-content: center;
    justify-content: center;
  `}

  @media(max-width: 959px) {
    flex-grow: 1;
    flex-shrink: 1;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
  }
`;

const Title = styled.p`
  width: 100%;
  margin: 0 0 5px 0;
  padding: 0 0 0 7px;
  box-sizing: border-box;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1;
  text-align: left;
  color: ${({ theme }) => theme.foreground};
`;

const ChildrenContainer = styled.div`
  width: 100%;
`;

type Props = {
  title?: React.Node,
  share?: boolean | void | number,
  buttonRow?: boolean,
  children?: any
};

function Row(props: Props) {
  return (
    <Container share={props.share} buttonRow={props.buttonRow}>
      {props.title && <Title>{props.title}</Title>}
      <ChildrenContainer>
        {props.children}
      </ChildrenContainer>
    </Container>
  );
}

export default Row;



// WEBPACK FOOTER //
// ./src/components/Popup/Row.js